module.exports = {
	'test': 'foo pt',


	/* MENU */

	'menu_home': 'HOME',
	'menu_about_us': 'ABOUT US',
	'menu_investors': 'INVESTORS',
	'menu_contacts': 'CONTACTS',
	'menu_portfolio': 'PORTFOLIO',

	/*HOME PAGE*/

	'home_welcome_title': 'WELCOME',
	'home_welcome_txt': 'Sonagi develops its activity in a sustained way, balancing the promotion activities with the management of real estate assets, thus becoming a reference of quality in Portugal.',
	'home_thumbs_about_title': 'ABOUT US',
	'home_thumbs_about_txt': 'Get to know Sonagi and learn more about its values, strategy and team.',
	'home_thumbs_portfolio_title': 'PORTFOLIO',
	'home_thumbs_portfolio_txt': 'Sonagi is specialised in office, residential, retail and industrial sectors. Learn more about our real estate investments.',
	'home_thumbs_investors_title1': 'INVESTORS',
	'home_thumbs_investors_title2': 'AND SHAREHOLDERS',
	'home_thumbs_investors_txt': 'The main objective of Sonagi is to gain the trust of its shareholders and investors through total transparency and to provide them with sustainable growth.',
	'home_portfolio_title': 'FEATURED PORTFOLIO',
	'home_real_estate_title': 'EXCELLENCE AND INNOVATION',
	'home_real_estate_txt': 'Sonagi is a real estate company which operates in the areas of investment, asset management and real estate development. Its main shareholder of reference is Sodim, the holding company of the Queiroz Pereira family.',
	'home_ft_portfolio_txt': '',

	/*PRIVACY POLICY*/

	'privacy_policy_title': 'PRIVACY POLICY',
	'privacy_policy_welcome_txt': 'Find out what data we collect and how we process it.',
	'privacy_policy_articles': [
		{
			'title': 'IDENTIFICATION OF THE DATA CONTROLLER',
			'text': '<ul><li>Company: Sonagi - Imobiliária, S.A. ("SONAGI")</li><li>Head Office: Av. Fontes Pereira de Melo, 14 - 7.º, 1050-121 Lisboa</li><li>Legal Person Identification Number: 502888083</li><li>Telephone: (+351) 213 184 800</li><li>E-mail: <a href="mailto: sonagi@sonagi.pt" class="icon-link">sonagi@sonagi.pt</a></li></ul>',
		},
		{
			'title': 'INFORMATION AND CONSENT',
			'text': 'The Data Protection Act (hereinafter "DPA") and the General Data Protection Regulation (Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016, hereinafter "GDPR") shall ensure the protection of natural persons with regard to the processing of personal data and the free circulation of such data. According to the law, personal data is any "information relating to an identified or identifiable natural person ("the data holder"); an identifiable person is considered to be identifiable, directly or indirectly, in particular by reference to an identifier, such as a name, an identification number, location data, identifiers by electronic means or to one or more specific elements - physical, physiological, genetic, mental, economic, cultural or social - of that natural person."<br><br>The protection of the personal data of those who in any way relate to SONAGI constitutes a fundamental commitment of our company, therefore we work daily to ensure the best levels of protection of the personal data that we process, respecting the legislation and all national and European guidelines applicable to data processing.<br><br>While managing the relationship with our suppliers, service providers, customers and users, we can access their personal data, as well as access the data of SONAGI directors and collaborators. By accepting this Privacy Policy, we intend to inform you how SONAGI processes this personal data and the purposes for which it is processed, along with informing the rights of data holders and how those rights may be exercised.<br><br>In no case will SONAGI carry out any of the following activities with the personal data provided through this site, without the express prior consent of the data owner:<br><br><ul>I.  Deliver it to other persons or other entities, and/or<br>II.  Transfer it outside the European Economic Area (EEA).</ul>',
		},
		{
			'title': 'PURPOSE OF THE PROCESSING OF PERSONAL DATA',
			'text': 'The personal data processed by SONAGI will only be used for the following purposes:<br><br><ul>I.  Compliance with legal obligations;</br>II.  Management of contractual relationships with clients and suppliers;</br>III.  Business prospecting;</br>IV.  Processing of information requests;</br>V.  Claim processing.</ul>',
		},
		{
			'title': 'SAFETY PRECAUTIONS',
			'text': 'SONAGI states that it has implemented and will continue to implement the security measures of a technical and organizational nature necessary to ensure the security of the personal data provided, in order to prevent its alteration, loss, unauthorized processing and/or access, taking into account the current state of the technology, the nature of the data stored and the risks to which they are exposed.<br><br>SONAGI guarantees the confidentiality of the data provided through this website.<br><br>The personal data is processed with the level of protection legally required to guarantee its security and prevent unauthorized alteration, loss, treatment or access, taking into account the state of the technology, being the user aware and accepting that the measures of Internet security are not impregnable.<br><br>Whenever SONAGI accesses personal data, it undertakes to:<br><br><ul><li>Store it by means of legally enforceable security measures of a technical and organizational nature that guarantee their safety, thus avoiding unauthorized alteration, loss, processing or access, according to the current state of technology, the nature of the data and the possible risks to which they are exposed;</li><br><li>Use the data exclusively for the purposes previously defined;</li><br><li>Make sure that the data is handled only by the employees whose intervention is necessary to satisfy the request of the data holder, being the same obliged to duties of secrecy and confidentiality. Should the information be disclosed to third parties for said purposes, they should be required to keep the confidentiality in accordance with the provisions of this document.</li></ul>It is, however, your responsibility to guarantee and ensure that the computer you are using is properly protected from harmful software, computer viruses and worms. In addition, you should be aware that without the adoption of appropriate security measures (for example, safe configuration of the browsing program, up-to-date antivirus software, security barrier software and non-use of software of questionable origin) the risk of personal data and passwords to be accessed by third parties, without authorization to do so, is aggravated.',
		},
		{
			'title': 'EXERCISE OF RIGHTS',
			'text': 'In accordance with the provisions of the DPA and the GDPR, the user may exercise at any time his right to information, access, rectification, erasure, limitation, portability and opposition by means of a written request addressed to SONAGI by the following means:<br><br><ul><li>Postal address to: Av. Fontes Pereira de Melo, 14 – 7.º, 1050-121 Lisboa</li><li>Email to the e-mail address: <a href="mailto:sonagi@sonagi.pt" class="icon-link">sonagi@sonagi.pt</a></li></ul>',
		},
		{
			'title': 'CONTROL AUTHORITY',
			'text': 'Under legal terms, the data holder has the right to submit a complaint regarding the protection of personal data to the competent control authority, the National Data Protection Commission (CNPD) <a href="https://www.cnpd.pt" target="_blank" class="icon-link">www.cnpd.pt</a>',
		},
		{
			'title': 'COOKIES POLICY',
			'text': 'Cookies policy is an integral part of the privacy policy of SONAGI website. Accessing and browsing the website or the use of its services implies acceptance of the terms and conditions contained in the privacy policy.<br><br>To facilitate and provide a better browsing experience through the website, SONAGI informs you that it uses cookies or other files with similar functionality ("cookies").<br><br>Due to how Internet communication standards work, access to websites may involve the use of cookies. SONAGI is responsible for the cookies and for the treatment of the data obtained through the cookies, either of its own or of third parties, through its website, deciding on the purpose, content and use of the treatment of the collected data.<br><br><span style="font-weight: 700; text-decoration: underline">What is a cookie?</span><br><br>Cookies are files that contain small amounts of information that is downloaded to the user&apos;s device when you visit a web page. <br><br>The main objective is to recognize the user whenever he / she accesses the website, also allowing to improve the quality and to offer a better use of the website, in order to simplify navigation. <br><br>Cookies are essential to the functioning of the internet; they do not damage the user&apos;s equipment or device and, if enabled in the configuration of your browser, they help identify and resolve possible errors in the operation of the website.<br><br><span style="font-weight: 700; text-decoration: underline">Use of cookies by SONAGI</span><br><br>By accessing the website, you expressly accept the use of this type of cookies on your devices. If you disable cookies, your website navigation may not be optimized, and some of the features on the website may not work correctly.<br><br>SONAGI uses cookies specifically for the purposes identified above and in case SONAGI uses other cookies for the purpose of granting more and better services, the user will be informed accordingly.<br><br><span style="font-weight: 700; text-decoration: underline">User setup to prevent cookies</span><br><br>In accordance with current legislation, information is provided on how the user can configure the browser to manage and maintain their privacy and security in relation to cookies, through links to access the official support website of the main browsers so that they can decide whether or not to accept the use of cookies.<br><br>It is understood that the user accepts the use of cookies if he continues browsing this page without first proceeding to deactivate the cookies. Cookie settings can be changed in your browser preferences by following the instructions below:<br><br><ul><span style="font-weight: 700">Chrome:</span><br>I. Click "Settings" in the toolbar;<br>II. Click "Show advanced settings";<br>III. In the "Privacy" section, click "Content Settings";<br>IV. Select "Block data settings from websites";<br>V. You can change the following settings in the "Cookies" section: Delete cookies; Block cookies by default; Allow cookies by default; Keep cookies and website data by default until you quit your Internet browser; Create exceptions for cookies from specific websites or domains.<br><br><span style="font-weight: 700">Firefox:</span><br>I. Click the "Tools" menu;<br>II. Select "Options";<br>III. Click the "Privacy" icon;<br>IV. In the "Cookies" section, deactivate the "Accept cookies from sites" option;<br>V. Click "OK" to save your changes and close.<br><br><span style="font-weight: 700">Internet Explorer:</span><br>I. Click the "Tools" menu and choose "Internet Options";<br>II. Select the "Privacy" tab;<br>III. Move the bar until the phrase "Block all cookies" appears.<br><br><span style="font-weight: 700">Safari:</span><br>I. Select "Preferences";<br>II. In the top panel, select the "Privacy" icon;<br>III. In the "Accept cookies" section, select "Never".<br><br><span style="font-weight: 700">Other browsers:</span><br>Please look in the "help" menu of the internet browser or contact your provider.</ul>',
		}
	],

	/*INVESTORS*/

	'investors_title': 'INVESTORS',
	'investors_welcome_txt': 'The main objective of Sonagi is to gain the trust of its shareholders and investors through total transparency and to provide them with sustainable growth.',
	'investors_themes': [
		{
			'title': 'INVESTOR INFORMATION',
			'height': 600,
			'component': 'InvestorInfo',
			'opened': true,
			'params': {
				'trans': {
					'market_releases': 'MARKET RELEASES',
				},
				'market_releases': {
					'initial_slide': 0,
					'slider_items': [
						{
							'name': 'RESOLUTIONS GENERAL MEETING',
							'year': '23 APR 2026',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2026.pdf',
						},
						{
							'name': 'RESOLUTIONS GENERAL MEETING',
							'year': '19 MAY 2025',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2025.pdf',
						},
						{
							'name': 'RESOLUTIONS GENERAL MEETING',
							'year': '4 APR 2024',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2024.pdf',
						},
						{
							'name': 'RESOLUTIONS GENERAL MEETING',
							'year': '31 MAY 2023',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Sonagi_2023.pdf',
						},
						{
							'name': 'RESOLUTIONS EXTRAORDINARY GENERAL MEETING',
							'year': '12 DEC 2022',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_AG_Extraordinária_Sonagi_2022.pdf',
						},
						{
							'name': 'QUALIFYING HOLDINGS',
							'year': '2021',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_PQ_SonagiSGPS_202104.pdf',
						},
						{
							'name': 'QUALIFYING HOLDINGS',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sodim_Comunicado_PQ_Sonagi_2020.pdf',
						},
						{
							'name': 'MANAGEMENT TRANSACTION',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sodim_Comunicado_Dirigentes_Sonagi.pdf',

						},
						{	
							'name': 'QUALIFYING HOLDINGS',
							'year': '2019',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_PQ_2019.PDF',
						},
						{
							'name': 'STOCK CONVERSION',
							'year': '2017',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_CA_2017.pdf',
						},
						{
							'name': 'STOCK ACQUISITION',
							'year': '2015',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_AA_Longavia_2015.pdf',
						},
						{
							'name': 'STOCK ACQUISITION',
							'year': '2015',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Comunicado_Sonagi_AA_Cimilonga_2015.pdf',
						}
					],
				},
			},
		},
		{
			'title': 'REPORT',
			'height': 400,
			'component': 'Report',
			'opened': true,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'ANNUAL REPORT',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2025.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2024.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2023.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2022.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2021',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2021.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2020',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2020.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2019',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2019.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2018',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2018.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2017',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2017.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2016',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2016.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2015',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2015.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2014',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2014.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2013',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2013.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2012',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2012.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2011',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2011.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2010',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2010.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2009',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2009.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2008',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2008.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2007',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2007.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2006',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2006.pdf',
					},
					{
						'name': 'ANNUAL REPORT',
						'year': '2005',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/RC_SonagiSGPS_2005.pdf',
					},
				],
			},
		},
		{
			'title': 'STOCKS',
			'height': 600,
			'component': 'Stocks',
			'opened': false,
			'params': {
				'trans': {
					'stock_market': 'STOCK MARKET',
					'qualified_holdings': 'QUALIFYING HOLDINGS',
				},
				'stock_market': {
					'initial_slide': 0,
					'slider_items': [
						{
							'name': 'PAYMENT OF RESERVES',
							'year': '2023',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/PagamentoReservas_Sonagi_2023.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2021',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2021.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2020',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2020.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2019',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2019.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2018',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2018.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2017',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2017.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2007',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2007.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2006',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2006.pdf',
						},
						{
							'name': 'PAYMENT OF DIVIDENDS',
							'year': '2005',
							'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/pagdividendos_2005.pdf',
						},
					],
				},
			},
		},
		{
			'title': 'GENERAL MEETING',
			'height': 400,
			'component': 'GeneralMeeting',
			'opened': false,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'GENERAL MEETING PROPOSALS',
						'year': '2026',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Propostas_AG_Sonagi_2026_VF.pdf',
					},
					{
						'name': 'ANNUAL NOTICE',
						'year': '2026',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2026.pdf',
					},
					{
						'name': 'GENERAL MEETING PROPOSALS',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2025_Propostas.pdf',
					},
					/** 
					{
						'name': 'ANNUAL NOTICE',
						'year': '2025',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2025.pdf',
					},
					{
						'name': 'GENERAL MEETING PROPOSALS',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2024_Propostas.pdf',
					},
					{
						'name': 'GENERAL MEETING PROPOSALS',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/AG_SONAGI_2023_Propostas.pdf',
					},
					{
						'name': 'ANNUAL NOTICE',
						'year': '2024',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2024.pdf',
					},
					{
						'name': 'ANNUAL NOTICE',
						'year': '2023',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2023.pdf',
					},
					{
						'name': 'EXTRAORDINARY NOTICE AND PROPOSALS',
						'year': '12 DEC 2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_Extraodinaria_AG_2022.pdf',
					},
					{
						'name': 'ANNUAL NOTICE',
						'year': '2022',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Sonagi_Convocatoria_AG_2022.pdf',
					},
					*/
				],
			},
		},
		{
			'title': 'STATUTES',
			'height': 400,
			'component': 'Statues',
			'opened': false,
			'params': {
				'initial_slide': 0,
				'slider_items': [
					{
						'name': 'STATUTES', 
						'year': '2019',
						'href': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Estatutos_Sonagi_2019.pdf',
					},
				],
			},
		},
		{
			'title': 'CORPORATE GOVERNANCE',
			'height': 2500,
			'component': 'CorpGovernance',
			'opened': false,
			'params': {
				'trans': {
					
				},
				'team': {
					'SONAGI SGPS SA': {
						'General Meeting': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/005IconWoman_AboutUs.png',
								'position': 'Chairman',
								'name': 'Joana Esperança Fernandes Lopes Luís'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/005IconWoman_AboutUs.png',
								'position': 'Secretary',
								'name': 'Daniela Filipa Dias Romeiro'
							}
						],
						'Statutory Auditor': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Full Member',
								'name': 'KPMG & Associados – Sociedade de Revisores Oficiais de Contas, S.A., represented by Paulo Alexandre Martins Quintas Paixão'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Alternate Member',
								'name': 'Rui Filipe Dias Lopes'
							}
						],
						'Board of Directors': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Chairman',
								'name': 'Hugo Alexandre Lopes Pinto'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/005IconWoman_AboutUs.png',
								'position': 'Member',
								'name': 'Mafalda Mendes de Almeida de Queiroz Pereira'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Member',
								'name': 'Rui Tiago Trindade Ramos Gouveia'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Member',
								'name': 'Daniel Filipe dos Santos e Tareco'
							}
						]
					},
					'SONAGI IMOBILIÁRIA SA': {
						'General Meeting': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/005IconWoman_AboutUs.png',
								'position': 'Chairman',
								'name': 'Daniela Filipa Dias Romeiro'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/005IconWoman_AboutUs.png',
								'position': 'Secretary',
								'name': 'Joana Esperança Fernandes Lopes Luís'
							}
						],
						'Statutory Auditor': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Full Member',
								'name': 'KPMG & Associados – Sociedade de Revisores Oficiais de Contas, S.A., represented by Paulo Alexandre Martins Quintas Paixão'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Alternate Member',
								'name': 'Rui Filipe Dias Lopes'
							}
						],
						'Board of Directors': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Chairman',
								'name': 'Hugo Alexandre Lopes Pinto'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Member',
								'name': 'Rui Tiago Trindade Ramos Gouveia'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Member',
								'name': 'Daniel Filipe dos Santos e Tareco'
							}
						],
					},

				}
			},
		},
		{
			'title': 'CORPORATE HISTORY',
			'height': 1800,
			'component': 'History',
			'opened': false,
			'params': {
				'trans': {
					'history': 'History'
				},
				'history': {
					'1850 - 1900': {
						'opened': false,
						'height': 300,
						'content': '<p>1868 - Foundation of the company Companhia das Águas de Lisboa by decree no. 21.879 (previous and complementary legislation).</p>'
					},
					'1900 - 1950': {
						'opened': false,
						'height': 300,
						'content': '<p>1935 - Statutes redrafted.</p>'
					},
					'1950 - 2000': {
						'opened': false,
						'height': 1400,
						'content': `<p>1959 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 102. - III Series of 30/04/59.</p>
							<p>1964 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 92. - III Series of 17/04/64.</p>
							<p>1974 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 271. - III Series of 21/04/74.</p>
							<p>1977 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 102. - III Series of 30/05/77.</p>
							<p>1979 - Change of company name from Companhia das Águas de Lisboa to <b>SONAGI - Sociedade Nacional de Gestão e Investimentos, S. A.</b> published in Diário do Governo (Official Journal of Government) No 286. - III Series of 13/12/79.</p>
							<p>1980 - Rectification of the statutes published in Diário da República (Official Journal of Government) No 10, III series of 12/01/80.</p>
							<p>1981 - Capital Increase from Esc.:50 000 000$00 to Esc.:100 000 000$00 published in Diário da República (Official Journal of Government) No 179, III Series of 06/08/81 - page 9,712.</p>
							<p>1991 - Change of statutes published in Diário da República (Official Journal of Government) No 137, III Series of 18/06/91 – 3rd Supplement, page 10.112.</p>
							<p>1992 - Capital Increase from Esc.:100 000 000$00 to Esc.:200 000 000$00 published in Diário da República (Official Journal of Government) No 138, III Series of 17/06/92- Supplement, page 10 748.</p>
							<p>1997 - Change of statutes published in the Diário da República (Official Journal of Government) No 168, III Series of 23/07/97 (Articles 19 and 20 deleted and amended the wording of article 18);</p>
							<p>2000 - Change of statutes. Redenomination of shares through rounding of unit value to five Euros and consequently increase of capital in 2,404.21 Euros by the incorporation of free reserves (amendment of paragraph 1 of article 4 and paragraph 4 of article 12). Dispensation of publication in Diário da República (Official Journal of Government) –Decree No 343/98.</p>
							`
					},
					'2000 - Present': {
						'opened': false,
						'height': 900,
						'content':	`<p>2002 - Change of statutes published in the Diário da República (Official Journal of Government) No 210, III Series of 11/09/02 (amendment of the second article).</p>
							<p>2003 - Change of statutes published in the Diário da República (Official Journal of Government) No 233, III Series of 08/10/03 (amendment of the third article).</p>
							<p>2003 - Change of company name from <b>SONAGI - Sociedade Nacional de Gestão e Investimento, S.A. to SONAGI, SGPS, S. A.</b>, published in the Diário da República (Official Journal of Government) No 292, III Series of 15/12/2004.</p>
							<p>2006 - Change of statutes published in the Portal of the Ministry of Justice in 06/07/06. Amendment of paragraph 1 of article 4; line a) of paragraph 2 and paragraph 3 of article 7; and paragraph 1 of Article 11 (change of the nominal value of the actions from EUR 5,00 to EUR 1,00; increase in capital from EUR 1,000,000.00 for Euro 10,000,000 ,00).</p>
							<p>2019 - Merger of Longavia - Imobiliária and Sonagi - Imobiliária with Cimilonga - Imobiliária and change of company name to Sonagi - Imobiliária, S.A.</p>
						`
					},
				},
			},
		}
	],


	/*ABOUT US*/

	'about_title': 'ABOUT US',
	'about_welcome_txt': 'Get to know Sonagi and learn more about its values, strategy and team.',
	'about_intro_title': 'SONAGI',
	'about_intro_text': 'Sonagi is a real estate company which operates in the areas of investment, asset management and real estate development. Its shareholder of reference is Sodim, the holding company of the Queiroz Pereira family.',
	'about_values': 'VALUES',
	'about_values_vision_title': 'VISION',
	'about_values_mission_title': 'MISSION',
	'about_values_vision_text': 'The objective of Sonagi is to attain a position of prominence in Portugal’s real estate sector, by being recognised not only for its ethical principles but also for its standards of excellence and innovation.',
	'about_values_mission_text': 'To promote real estate products and services, and to add value for shareholders, maintaining a perspective of sustainable development and a high social and environmental awareness.',
	'about_themes': [
		/*{
			'title': 'STRATEGIC PRINCIPLES',
			'height': 600,
			'component': 'StrategicPrinciples',
			'opened': false,
			'params': {
				'trans': {
					
				},
				'content': `<p>It is Sonagi’s strategy to operate in all sectors of real estate:</p>

					<div>
						<p>1. Creating products in each sub-sector that meet the highest standards of quality and innovation;</p>

						<p>2. Granting the best resources and guidance in an environment of understanding and support in order to maximize success and achieve the client’s goals;</p>

						<p>3. Creating long-lasting relationships through ethical standards of integrity, professionalism, service and innovation;</p>

						<p>4. Growing by creating value to the shareholder without overlooking the principles of social and environmental awareness;</p>

						<p>5. Searching for business opportunities that create value through acquisitions.</p>
					</div>`
			},
		},
		/*{
			'title': 'STATUTES',
			'height': 50,
			'component': 'Statutes',
			'opened': false,
			'params': {
				'trans': {
					'file_name': 'Sonagi SGPS Statutes',
				},
				'file': process.env.VUE_APP_ASSETS_ROOT+ 'docs/Estatutos_Sonagi_2019.pdf',
			}
		},*/
		{
			'title': 'TEAM',
			'height': 2500,
			'component': 'Team',
			'opened': false,
			'params': {
				'trans': {
					
				},
				'team': {
					'SONAGI IMOBILIÁRIA SA': {
						'Board of Directors': [
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'CEO',
								'name': 'Daniel Tareco'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Head of Finance',
								'name': 'Carlos Ferreira'
							},
							{
								'avatar': process.env.VUE_APP_ASSETS_ROOT+'img/004IconMan_AboutUs.png',
								'position': 'Head of Asset Management',
								'name': 'João Lúcio'
							}
						]
					},

				}
			},
		},
		/*{
			'title': 'HISTORY OF COMPANY\'S RELEVANT FACTS',
			'height': 1800,
			'component': 'History',
			'opened': false,
			'params': {
				'trans': {
					'history': 'History'
				},
				'history': {
					'1850 - 1900': {
						'opened': false,
						'height': 300,
						'content': '<p>1868 - Foundation of the company Companhia das Águas de Lisboa by decree no. 21.879 (previous and complementary legislation).</p>'
					},
					'1900 - 1950': {
						'opened': false,
						'height': 300,
						'content': '<p>1935 - Statutes redrafted.</p>'
					},
					'1950 - 2000': {
						'opened': false,
						'height': 1400,
						'content': `<p>1959 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 102. - III Series of 30/04/59.</p>
							<p>1964 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 92. - III Series of 17/04/64.</p>
							<p>1974 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 271. - III Series of 21/04/74.</p>
							<p>1977 - Change of statutes published in the Diário do Governo (Official Journal of Government) No 102. - III Series of 30/05/77.</p>
							<p>1979 - Change of company name from Companhia das Águas de Lisboa to <b>SONAGI - Sociedade Nacional de Gestão e Investimentos, S. A.</b> published in Diário do Governo (Official Journal of Government) No 286. - III Series of 13/12/79.</p>
							<p>1980 - Rectification of the statutes published in Diário da República (Official Journal of Government) No 10, III series of 12/01/80.</p>
							<p>1981 - Capital Increase from Esc.:50 000 000$00 to Esc.:100 000 000$00 published in Diário da República (Official Journal of Government) No 179, III Series of 06/08/81 - page 9,712.</p>
							<p>1991 - Change of statutes published in Diário da República (Official Journal of Government) No 137, III Series of 18/06/91 – 3rd Supplement, page 10.112.</p>
							<p>1992 - Capital Increase from Esc.:100 000 000$00 to Esc.:200 000 000$00 published in Diário da República (Official Journal of Government) No 138, III Series of 17/06/92- Supplement, page 10 748.</p>
							<p>1997 - Change of statutes published in the Diário da República (Official Journal of Government) No 168, III Series of 23/07/97 (Articles 19 and 20 deleted and amended the wording of article 18);</p>
							<p>2000 - Change of statutes. Redenomination of shares through rounding of unit value to five Euros and consequently increase of capital in 2,404.21 Euros by the incorporation of free reserves (amendment of paragraph 1 of article 4 and paragraph 4 of article 12). Dispensation of publication in Diário da República (Official Journal of Government) –Decree No 343/98.</p>
							`
					},
					'2000 - Present': {
						'opened': false,
						'height': 900,
						'content':	`<p>2002 - Change of statutes published in the Diário da República (Official Journal of Government) No 210, III Series of 11/09/02 (amendment of the second article).</p>
							<p>2003 - Change of statutes published in the Diário da República (Official Journal of Government) No 233, III Series of 08/10/03 (amendment of the third article).</p>
							<p>2003 - Change of company name from <b>SONAGI - Sociedade Nacional de Gestão e Investimento, S.A. to SONAGI, SGPS, S. A.</b>, published in the Diário da República (Official Journal of Government) No 292, III Series of 15/12/2004.</p>
							<p>2006 - Change of statutes published in the Portal of the Ministry of Justice in 06/07/06. Amendment of paragraph 1 of article 4; line a) of paragraph 2 and paragraph 3 of article 7; and paragraph 1 of Article 11 (change of the nominal value of the actions from EUR 5,00 to EUR 1,00; increase in capital from EUR 1,000,000.00 for Euro 10,000,000 ,00).</p>
						`
					},
				},
			},
		}*/
	],

	/*PORTFOLIO*/

	'portfolio_title': 'PORTFOLIO',
	'description': 'HIGHLIGHTS',
	'availability': 'AVAILABILITY',
	'related_projects_txt': 'RELATED PROJECTS',
	'availability_href_txt': 'Click here to know more',
	'portfolio_welcome_txt':  'Learn more about our real estate investments.',
	'projects_categories': [
		{
			'name': 'INVESTMENT PROPERTIES',
			'name_portfolio': 'INVESTMENT PROPERTIES',
			'slug': 'real-estate-investement',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+'img/RealEstateInvestment_FeaturedPortfolio.jpg',
			'show_on_home': true,
		},
		{
			'name': 'DEVELOPMENT',
			'name_portfolio': 'DEVELOPMENT',
			'slug': 'real-estate-promotion',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+'img/RealEstatePromotion_FeaturedPortfolio.jpg',
			'show_on_home': true,
		},
		{
			'name': 'ALL',
			'name_portfolio': 'ALL',
			'slug': 'all',
			'thumb': process.env.VUE_APP_ASSETS_ROOT+'img/DevelopedProjects_FeaturedPortfolio.jpg',
			'show_on_home': false,
		}
	],
	'projects': [
		{
			'id': 1,
			'name': 'FONTES PEREIRA DE MELO 14',
			'slug': 'fpm14',
			'tab_title': 'Fontes Pereira de Melo 14',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Prime business district offices',
			'abreviature': 'FPM14',
			'related_projects': [2, 12, 13],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '8.300 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '600 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '15 floors'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/Y5wpj5qfvBLkde649'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_FPM14.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_FPM14.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_FPM14.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This corporate building is situated in the heart of the city in one of the most renowned business areas in Lisbon. Located a few metres from Praça Marquês de Pombal, it has been the headquarters of several prestigious companies since its construction. Continuously being updated, it articulates the needs that present-day offices have with timeless architecture.',
			'description': '- Prime Business District<br>- Good access to public transport network<br>- Main tenants: Semapa, LinkLaters, Auto Industrial<br>- Basement parking',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_24.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_25.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_23.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM14_12.jpg',
			]
		},
		{
			'id': 2,
			'name': 'FONTES PEREIRA DE MELO 21',
			'slug': 'fpm21',
			'tab_title': 'Fontes Pereira de Melo 21',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Prime business district offices',
			'abreviature': 'FPM21',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '1.980 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '204 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '10 floors'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/NuaE3jvpscbEzuZc8'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_FPM21.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_FPM21.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_FPM21.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This building is situated in the heart of the city, in a prime location associated with business prestige. It is a building of quality with medium-sized offices, served by an excellent transport network. Having all the necessary amenities, it is the ideal solution for the operation of companies in a privilege a corporate environment.',
			'description': '- Prime Business District<br>- Good access to public transport network<br>- Main tenants: Olhar de Prata, Optimize, Notário Frederico Soares Franco, Integrative Medicine<br>- Basement parking',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_37.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_3.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFPM21_8.jpg', */
			]
		},
		{
			'id': 3,
			'name': 'ANTÓNIO AUGUSTO DE AGUIAR 122',
			'slug': 'aaa122',
			'tab_title': 'António Augusto de Aguiar 122',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Prime business district offices',
			'abreviature': 'AAA122',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '5.800 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '480 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '16 floors'
				},
			/*	/{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/NuaE3jvpscbEzuZc8'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_AAA112_2.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_AAA112_2.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_AAA112_2.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This building is located next to Corte Inglês and the São Sebastião metro station. In 2022 was totally refurbished to aim current offices best standards.',
			'description': '- Prime Business District<br>- Next to El Corte Inglês<br>- Good access to public transport network<br>- Basement parking<br>- Tenant: IdeaSpaces',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				/* process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_1.jpg', 
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_2.jpg',
				/*process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_4.jpg',
				/*process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_7.jpg' */
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_8.jpg', 
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_13.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_15.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAAA112_16.jpg'
			]
		},
		{
			'id': 15,
			'name': 'JEAN MONNET 1',
			'slug': 'jm1',
			'tab_title': 'Jean Monnet 1',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Prime business district offices',
			'abreviature': 'JM1',
			'related_projects': [1, 2, 3],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/M2_PaginaProjeto.svg',
					'description': '6.500 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floor_PaginaProjeto.svg',
					'description': '805 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+ 'img/Floors_PaginaProjeto.svg',
					'description': '8 floors'
				}
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JM1.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+ 'img/header_JM1.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+ 'img/Thumbnail_JM1.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Landmark building located in the Prime CBD, next to the Avenida da Liberdade axis, in the city’s most prestigious business district. The surrounding area offers a wide range of retail spaces and renowned hotels, and benefits from an excellent transport network. Following an extensive refurbishment in 2024, the building is fully adapted to the current needs of the office market.',
			'description': '- Prime Business District<br>- Good access to public transport network<br>- Main tenants: Explorer, Insula, InformaDB, MFA Legal<br>- Basement parking',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+ 'img/SonagiJM1_6.jpg'
			]
		},
		{
			'id': 4,
			'name': 'JOAQUIM ANTÓNIO DE AGUIAR 66',
			'slug': 'jaa66',
			'tab_title': 'Joaquim António de Aguiar 66',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Offices',
			'abreviature': 'JAA66',
			'related_projects': [2, 13, 12],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '3.800 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '554 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '8 floors'
				},
		/*		{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/FU72dbU3Yiv8NsAv9'
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_JAA66.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_JAA66.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_JAA66.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This building, located at the intersection of Rua Artilharia 1 and Rua Joaquim António de Aguiar, has been the headquarters of several law firms. Situated on the Marquês de Pombal - Amoreiras axis, it offers quality offices with all the technical conditions required for the operation of companies.',
			'description': '- Marquês de Pombal/Amoreiras axis<br>- Good access to public transport network<br>- Main tenants: Summer C Colors, ArgoTalents, ATPR Advogados<br>- Ground floor parking',
			'availability': 'Spaces of 250 and 550 sqm',
			'availability_hrefs': [
				{
					'href': 'https://www.worx.pt/pt/imoveis/edificio-joaquim-antonio-aguiar-66',
					'text': 'Worx'
				},
				{
					'href': 'https://jllproperty.pt/arrendar-escritorio/escritorio-para-arrendar-lisboa-931',
					'text': 'JLL'
				}
			],
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiJAA66_6.jpg',
			]
		},
		/* {
			'id': 5,
			'name': 'CICAS',
			'slug': 'cicas',
			'tab_title': 'Cicas',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Retail and industry',
			'abreviature': 'CICAS',
			'related_projects': [4, 6, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '3.020 sqm'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Buildings_PaginaProjeto.svg',
					'description': '4 buildings'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Carnaxide',
					'href': 'https://goo.gl/maps/3CzeHYMPz13f9ZfL9'	
				}, 
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_Cicas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_Cicas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_CICAS.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Delphy’s former cable factory is located at the Cicas roundabout, south of Santa Cruz Hospital. With a modern and current architecture, it has been successively occupied by companies in the automotive industry.',
			'description': '- Private parking<br>- Good road access<br>- Close to Lisbon<br>- Tenant: Leaseplan',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCicas4.jpg',
			]
		}, */
		{
			'id': 7,
			'name': 'FRANCISCO MANUEL DE MELO 12',
			'slug': 'fmm12',
			'tab_title': 'Francisco Manuel de Melo 12',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Residential and retail',
			'abreviature': 'FMM12',
			'related_projects': [14, 3, 11],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '1.623 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '182 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Buildings_PaginaProjeto.svg',
					'description': '5 apartments'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/PkcLwesstrXd6WJt7'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_FMM12.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_FMM12.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_FMM12.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This building, situated in the centre of Lisbon, is integrated in a prestigious area of the city. Located next to Hotel Ritz, Parque Eduardo VII, Praça Marquês de Pombal and Centro Comercial das Amoreiras, it has easy access to the public transport network system of metropolitan Lisbon, as well as to excellent access to roadways (Eixo Norte/Sul, A2 and A5).',
			'description': '- Central location<br>- Good access to public transport network',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_7.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiFMM12_1.jpg', */
			]
		},
		{
			'id': 8,
			'name': 'AZINHAGA DAS GALHARDAS',
			'slug': 'galhardas',
			'tab_title': 'Azinhaga das Galhardas',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Retail',
			'abreviature': 'GALHARDAS',
			'related_projects': [2, 3, 5],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '4.030 m<sup>2</sup>'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/rHBPiuTsSKVyGSCBA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_Galhardas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_Galhardas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_GALHARDAS.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Inserted in a high-quality residential complex, located in Telheiras, close to Estádio Universitário and Universidade Católica, it is a basement, occupied by a commercial area. It has access to the public transport network of metropolitan Lisbon, as well as to excellent access to roadways (Eixo Norte/Sul and 2ª Circular).',
			'description': '- Praça de Espanha/2ª Circular axis<br>- Good access to roadways<br>- Public parking<br>- Tenant: Pingo Doce',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiGalhardas_8.jpg',
			]
		},
		{
			'id': 9,
			'name': 'PARQUE DAS CICAS',
			'slug': 'parque-cicas',
			'tab_title': 'Parque das Cicas',
			'dinamic_title': 'PLANNERS',
			'teaser': 'Residential and offices',
			'abreviature': 'PARQUE DAS CICAS',
			'related_projects': [5, 11, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '37.870 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '4 lots'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisboa',
					'href': 'https://goo.gl/maps/CygxZP3qJ6fdurB59'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_Cicas.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_Cicas.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_PCicas.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'The industrial pavilions of the old cable factory acquired in 2003 were initially adapted for logistics and are still in use. Situated in the natural extension of the residential area of Carnaxide, adjacent to Hospital de Santa Cruz and Parque Holanda (office and industrial complex), this industrial "island" will soon undergo an urbanistic reconversion, adjusting to the surrounding reality.',
			'description': '<a href="https://www.cunhaferreira-arquitectos.pt/" target="_blank">Cunha Ferreira Architects</a>',
			'availability': 'Project under appraisal',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_1.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_2.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_3.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_4.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_5.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_6.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_7.jpeg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiPCicas_8.jpeg',
			]
		},
		{
			'id': 6,
			'name': 'MEM MARTINS BUSINESS PARK',
			'slug': 'mmbp',
			'tab_title': 'Mem Martins Business Park',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Offices and industrial',
			'abreviature': 'MMBP',
			'related_projects': [4, 5, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '13.205 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Buildings_PaginaProjeto.svg',
					'description': '8 buildings'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Sintra',
					'href': 'https://goo.gl/maps/KV8ahYtRuxhP4gTbA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_MBP.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_MBP.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_MBP_pb.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Located in Mem Martins next to Sintra Retail Park, just 15 km from Lisbon, this business park has 6 logistics halls and 2 office buildings. The expansion of the logistics area, with the construction of 8 new warehouses, equipped with loading and unloading docks, is to be expected soon. Owned by Sonagi between 2005 and 2026.',
			'description': '- Enclosed business park with security<br>- Close to the IC19 and the A16',
			'availability': 'Warehouses with 1.230 m<sup>2</sup> and 240 m<sup>2</sup>',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMBP_2.jpg',
			]
		},
		{
			'id': 5,
			'name': 'ALFA',
			'slug': 'alfa',
			'tab_title': 'Alfa',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Offices and industrial',
			'abreviature': 'ALFA',
			'related_projects': [5, 6, 9],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '4.650 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Warehouse_PaginaProjeto.svg',
					'description': '3 warehouses'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '3 office floors'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Carnaxide',
					'href': 'https://goo.gl/maps/ACdqTBvyF72Jk3nw8'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_ALFA.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_ALFA.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_ALFA2.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'Situated in Carnaxide, near the access to the A5, this building has large areas for offices and logistics, ideal for headquarters of companies in need of these conditions. Owned by Sonagi between 2006 and 2026.',
			'description': '- Warehouses with high ceilings<br>- Covered private parking<br>- Additional outdoor parking',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa2.jpg',
			/*	process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiAlfa3.jpg', */
			]
		},
		{
			'id': 10,
			'name': 'ALDEIA DA ROCA',
			'slug': 'Roca',
			'tab_title': 'Aldeia da Roca',
			'dinamic_title': 'PLANNERS',
			'teaser': 'Residential',
			'abreviature': 'ALDEIA DA ROCA',
			'related_projects': [11, 7, 14],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '2.850 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Buildings_PaginaProjeto.svg',
					'description': '16 apartments'
				},
		/*		{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Sintra',
					'href': 'https://goo.gl/maps/g7xuGM7Npe8bRRcw5'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_ROCA.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_ROCA.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_ROCA.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'Situated in Azóia, next to Cabo da Roca, right in the heart of Parque Natural Sintra Cascais, this residential development will provide apartments with panoramic views of the hills and the sea. Located 35 minutes from Lisbon and 10 minutes from Praia do Guincho or Praia Grande, it is depicted as a pleasant haven of nature and tranquillity.',
			'description': '<a href="https://www.antoniocostalima.com/" class="icon-link" target="_blank">António Costa Lima Architects</a>',
			'availability': 'Project under appraisal',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_12.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_13.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRoca_10.jpg',
			]
		},
		{
			'id': 11,
			'name': 'MIGUEL BOMBARDA 95',
			'slug': 'mb95',
			'tab_title': 'Miguel Bombarda 95',
			'dinamic_title': 'PLANNERS',
			'teaser': 'Residential and retail',
			'abreviature': 'MB95',
			'related_projects': [1, 14, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '3.935 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Stores_PaginaProjeto.svg',
					'description': '3 shops'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Buildings_PaginaProjeto.svg',
					'description': '17 apartments'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/CygxZP3qJ6fdurB59'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_MB95.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_MB95.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_MB95.jpg',
			'categories': ['real-estate-promotion', 'all'],
			'text': 'Located in Avenidas Novas, at the corner of two wide avenues lined on both sides by jacarandas, this building completed in 2014 has a unique setting. Built in front of a garden, just a dozen metres from the dynamic axes of the business world, it simultaneously allows one to enjoy the tranquillity and liveliness of the city: wandering along bicycle paths, enjoying the Gulbenkian gardens, El Corte Inglês, neighbourhood grocery stores and the flavours of the Versailles pastry shop.',
			'description': '<a href="https://www.arch-rms.com/" target="_blank">Rodrigo Machado Soares</a>',
			'availability': 'Sold',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_12.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_14.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_8.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_2.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_4.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_10.jpg',
				//process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiMB95_13.jpg',
			]
		},
		{
			'id': 12,
			'name': 'OPEN',
			'slug': 'open',
			'tab_title': 'Open',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Offices',
			'abreviature': 'OPEN',
			'related_projects': [1, 2, 3],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': '7.430 m<sup>2</sup>'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '13 floors'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/rw8wisiZgqwGKbLPA'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_OPEN.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_OPEN.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_OPEN.jpg',
			'categories': ['real-estate-promotion', 'real-estate-investement', 'all'],
			'text': 'Located on Avenida das Forças Armadas in Lisbon, next to Hospital de Santa Maria and Cidade Universitária, it is characterized as being a high-quality office building with shops, a cafeteria and security 24/7. Designed in a modern architectural style, it is composed of several windows all along its facade, thus offering plenty of natural light. It also has public and private parking.',
			'description': '- Property of SONAGI until 2006<br>- High-quality offices<br>- Modern architecture<br>- Open space areas',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_11.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_10.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiOpen_3.jpg',
			]
		},
		{
			'id': 13,
			'name': 'CENTRAL PARK',
			'slug': 'centralpark',
			'tab_title': 'Central Park',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Offices and retail',
			'abreviature': 'CENTRAL PARK',
			'related_projects': [12, 1, 3],
			'icons': [
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/M2_PaginaProjeto.svg',
					'description': 'X sqm'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': 'X floors'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/ULxB3ksC1rKb7ZXf9'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_CentralPark.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_CentralPark.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_CENTRALPARK.jpg',
			'categories': ['real-estate-promotion', 'real-estate-investement', 'all'],
			'text': 'This building is located on the main avenue of Linda-a-Velha next to the A5. It is characterized as a mixed-use building that benefits from a wide variety of services (Dolce Vita Central Park / Commercial Centre), as well as from a large area of good quality offices, all of which have modern amenities essential to companies.',
			'description': '- Property of SONAGI until 2006<br>- Mixed-use building: offices and retail<br>- High-quality construction<br>- Open space areas',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiCentralPark6.jpg',
			]
		},
		{
			'id': 14,
			'name': 'RODRIGUES SAMPAIO 52',
			'slug': 'Residential and retail',
			'tab_title': 'Rodrigues Sampaio 52',
			'dinamic_title': 'HIGHLIGHTS',
			'teaser': 'Residential and retail',
			'abreviature': 'RS52',
			'related_projects': [7, 11, 8],
			'icons': [
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floor_PaginaProjeto.svg',
					'description': '240 m<sup>2</sup>/floor'
				},
				{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Floors_PaginaProjeto.svg',
					'description': '6 floors'
				},
			/*	{
					'img': process.env.VUE_APP_ASSETS_ROOT+'img/Location_PaginaProjeto.svg',
					'description': 'Lisbon',
					'href': 'https://goo.gl/maps/5KwMfY4WjMFFDPQw7'	
				}, */
			],
			'top_image': {
				'desktop': process.env.VUE_APP_ASSETS_ROOT+'img/header_RS52.jpg',
				'mobile': process.env.VUE_APP_ASSETS_ROOT+'img/header_RS52.jpg',
			},
			'thumbnail': process.env.VUE_APP_ASSETS_ROOT+'img/Thumbnail_RS52.jpg',
			'categories': ['real-estate-investement', 'all'],
			'text': 'This residential and commercial building is located in the very heart of Lisbon, at the corner of the access to the most famous street of the city, Avenida da Liberdade. Known as the Portuguese Champs Elysées, it is possible to find here, world-renowned shops and companies. In open contrast to this modernism, the building stands out as an icon of traditional architecture, mirroring on its facade the eclectic aesthetics of the 50s.',
			'description': '- Property of SONAGI between 1954 and 2006<br>- Central location<br>- Traditional Portuguese architecture',
			'availability': 'Not available',
			'initial_slide': 0,
			'slider_images': [
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_2.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_3.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_4.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_5.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_6.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_8.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_1.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_9.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_7.jpg',
				process.env.VUE_APP_ASSETS_ROOT+'img/SonagiRS52_10.jpg',	
			]
		},
	],

	/*CONTACTS*/
	
	'contacts_title': 'CONTACTS',
	'contacts_txt': 'If you have any further questions, please feel free to contact us.',
	'address': 'ADDRESS',
	'phone': 'PHONE',



	/*404 PAGE*/


	'404_error_title': 'THE PAGE YOU\'RE LOOKING FOR CAN\'T BE FOUND.',
	'404_error_text': 'Error 404'

}